export function convertTitleToParamCase(str = '', isLowerCase = false) {
  if (!str) {
    return '';
  }

  const result = str.split(' ').join('-');
  return !isLowerCase ? result : result.toLowerCase();
}
